angular.module('wbDashboard').controller('AutoDepositControllerAurea',
    ['$scope', '$timeout', '$uibModal', '$q', 'Message', 'Milestone', 'User', 'PlanService', 'FormulaService',
function ($scope, $timeout, $uibModal, $q, Message, Milestone, User, PlanService, FormulaService) {

    $scope.frequencies = PlanService.info.fastmoney.flexibleautodeposits.frequencies;

    PlanService.user.retrieveAutos();
    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    $scope.$watchCollection(function() { return User.getMSandWallet(); }, function(milestones) {
        if (milestones) {
            $scope.milestones = milestones;

            angular.forEach($scope.milestones, function(ms) {
                if (ms.type === 'wallet' && !ms.auto_deposit.recommended) {
                    FormulaService.getFormulasAutoRecommend({formulaSlug: 'waahoooo'}).then(function(deposits) {
                        ms.auto_deposit.recommended = deposits.auto.total;
                    });
                }

            });

        }
    });

    $scope.updateAutoDeposit = function(frequency) {
        var data;
        switch (frequency) {
            case "Weekly":
                data = {
                    frequency: "Weekly",
                    frequency_weekday: "Monday"
                };
                break;
            case "Monthly":
                data = {
                    frequency: "Monthly",
                    frequency_dates: [1]
                };
                break;
        }
        $scope.pageData.sending = true;
        PlanService.user.updateAutos(data).then(function() {

            User.retrieveActivityPending(true);
            return $q.all([PlanService.user.retrieveAutos(), User.retrieveAllMilestones(true, true)]);
        }).then(function() {
            $scope.$state.go('^');
            Message.set({
                text: "Your auto-deposit frequency was successfully updated!",
                type: "success"
            });
        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });


    };

}]);
